import '@css/admin_css.scss';
import { setDateTimeLocalization } from '@racemap/utilities/functions/datetime';
import { ConfigProvider } from 'antd';
import { enableMapSet } from 'immer';
import { StrictMode } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createRoot } from 'react-dom/client';
import { themeConfig } from 'src/lib/theme';
import { UploadRouter } from './router/upload.router';

setDateTimeLocalization();

// makes the use of Map and Set in immer.js possible
enableMapSet();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <ConfigProvider theme={themeConfig}>
      <DndProvider backend={HTML5Backend}>
        <UploadRouter />
      </DndProvider>
    </ConfigProvider>
  </StrictMode>,
);
